import {Chip, Tooltip} from '@mui/material';
import {string} from 'prop-types';

const SingleSecretFoldersList = ({folders}) => {
  const MAXIMUM_NUMBER_OF_FOLDERS_DISPLAYED = 10;

  const foldersList = folders.split(',');
  const canAllFoldersFit = foldersList.length <= MAXIMUM_NUMBER_OF_FOLDERS_DISPLAYED;
  const foldersToDisplay = canAllFoldersFit ? foldersList : foldersList.slice(0, MAXIMUM_NUMBER_OF_FOLDERS_DISPLAYED);
  const numberOfInvisibleItems = foldersList.length - foldersToDisplay.length;
  const invisibleItemsList = foldersList.slice(MAXIMUM_NUMBER_OF_FOLDERS_DISPLAYED);

  return (
    <>
      {foldersToDisplay.map(folder => (
        <Chip role="button" sx={{mr: 0.5, mb: 0.5}} label={folder} size="small" />
      ))}

      {canAllFoldersFit ? null : (
        <Tooltip title={invisibleItemsList.join(',')}>
          <Chip role="button" sx={{cursor: 'pointer', mr: 0.5, mb: 0.5}} label={`+ ${numberOfInvisibleItems}`} size="small" />
        </Tooltip>
      )}
    </>
  );
};

SingleSecretFoldersList.propTypes = {
  folders: string.isRequired
};

export default SingleSecretFoldersList;
